import { ImageTags } from '@/constants/CompressorImageTagData.const';
import { Compressor } from '../../RoomConfigurationContent.utils';

export interface CompressorRowProps {
  compressor: Compressor;
  roomId: number;
  roomIndex: number;
  index: number;
  pressureType: string;
  isMobile: boolean;
  isTablet: boolean;
  onRemoveCompressor: (roomId: number, compressorIndex: number) => void;
  onUpdateManualCompressorField?: (roomId: number, compressorIndex: number, field: string, value: string) => void;
  onOpenCompressorImageUpload?: (compressorId: string, currentImageCount: number) => void;
  onEditCompressorImageTag?: (
    roomId: number,
    compressorIndex: number,
    id: number,
    newTag: ImageTags,
    oldTag: ImageTags,
  ) => void;
  onRemoveCompressorImage?: (roomId: number, compressorIndex: number, tag: ImageTags, imageId: number) => void;
  renderCompressorNumberInput: (roomId: number, compressorId: string, index: number) => React.ReactNode;
  renderModelSpecSelect: (
    roomId: number,
    compressorId: string,
    index: number,
    onNoMatchingSpecSelect?: () => void,
  ) => React.ReactNode;
  compressorsModelSpec: Compressor[];
}

export const getModalTitle = (
  serialNumber: string,
  manufacturer: string,
  compressorNumber: string,
  isManual: boolean,
) => {
  const titleParts = [];
  if (compressorNumber) {
    titleParts.push(`#${compressorNumber}`);
  }

  if (isManual) {
    if (manufacturer) {
      titleParts.push(manufacturer);
    }
  } else if (serialNumber) {
    titleParts.push(serialNumber);
  }

  return titleParts.join(' ');
};
